import { getDataByUrl, ID, postDataByUrl, updateDataByUrl } from './index';

/**
 * Get all HRM assessment questions
 */
export const getHrmAssessmentQuestions = () =>
  getDataByUrl('/api/assessment/hrm/questions/');

/**
 * Get specific HRM assessment by ID
 */
export const getHrmAssessment = (assessmentId: ID) =>
  getDataByUrl(`/api/assessment/hrm/${assessmentId}`);

/**
 * Get HRM assessment choices for a specific question
 */
export const getHrmAssessmentChoices = (questionId: ID) =>
  getDataByUrl(`/api/assessment/hrm/questions/${questionId}/choices/`);

/**
 * Submit HRM assessment answers
 */
export interface HrmAnswerSubmission {
  QuestionID: number;
  Answer: number;
}

export const submitHrmAssessmentAnswers = (
  assessmentId: ID,
  answers: HrmAnswerSubmission[],
  testStartTime: string,
  testEndTime: string
) =>
  updateDataByUrl(`/api/assessment/hrm/submit_answers/${assessmentId}/`, {
    answers,
    start_time: testStartTime,
    complete_time: testEndTime
  });

export const getMindgageMetrics = (language: string) =>
  getDataByUrl(
    `/api/assessment/mindgage_metrics/${language ? `?lang=${language}` : ''}`
  );

/**
 * Initiate Mindgage assessment test
 * POST to /api/assessment/assessments/ with {"type": 3}
 */
export const initiateMindgageAssessment = () =>
  postDataByUrl('/api/assessment/assessments/', { type: 3 });
